import React, { useEffect, useState } from "react";
import axios from "axios";
import { UserRound } from "lucide-react";
import { Section, Eyebrow } from "./ui-kit";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const TeamSection = () => {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    axios.get(`${API}/team`).then((r) => setTeam(r.data)).catch(() => {});
  }, []);

  if (team.length === 0) return null;

  return (
    <Section tone="white" data-testid="team-section">
      <div className="max-w-2xl">
        <Eyebrow>Meet the team</Eyebrow>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900">
          The friendly faces behind Spire
        </h2>
        <p className="mt-4 text-lg text-stone-700 leading-relaxed">
          Hover over (or tap) a card to find out a fun fact about each of us!
        </p>
      </div>
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {team.map((m) => (
          <div key={m.id} className="flip-card h-80" tabIndex={0} data-testid={`team-card-${m.id}`}>
            <div className="flip-inner relative h-full w-full">
              <div className="flip-front absolute inset-0 overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-sm">
                {m.image_url ? (
                  <img src={`${BACKEND}${m.image_url}`} alt={`${m.name}, ${m.role}`} className="h-3/4 w-full object-cover" loading="lazy" />
                ) : (
                  <div className="flex h-3/4 w-full items-center justify-center bg-orange-50 text-orange-300">
                    <UserRound className="h-20 w-20" aria-hidden="true" />
                  </div>
                )}
                <div className="p-4">
                  <p className="font-heading text-xl font-semibold text-stone-900">{m.name}</p>
                  <p className="text-base text-stone-600">{m.role}</p>
                </div>
              </div>
              <div className="flip-back absolute inset-0 flex flex-col items-center justify-center rounded-3xl bg-orange-600 p-6 text-center text-white">
                <p className="font-heading text-lg font-bold uppercase tracking-wide text-orange-100">Fun fact</p>
                <p className="mt-3 text-lg leading-relaxed">{m.fun_fact || "Ask me when you visit!"}</p>
                <p className="mt-4 font-heading font-semibold">— {m.name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};
